import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import oztix from "../hooks/oztixScript";
import { Helmet } from "react-helmet";
import Menu from "./menu";
import { Tickertape, Popup } from "../components";
import {
	Clouds,
	Goodthings,
	DoctorPunk,
	KidFlowers,
	BarEtc,
	ThankYou,
} from "../svg";
import "../styles/styles.scss";

/* Layout
============================================================================= */

const Layout = ({ children }) => {
	// Config

	useEffect(() => {
		oztix();
	}, []);

	// Render
	return (
		<>
			<Helmet>
				<script
					async
					src="https://www.googletagmanager.com/gtag/js?id=G-PR4619XGDY"
				></script>
				<script>
					{`window.dataLayer = window.dataLayer || [];
					function gtag() { dataLayer.push(arguments); }
					gtag('js', new Date());
					gtag('config', 'G-PR4619XGDY');
					gtag('config', 'G-Z6Q34PSGS3');
					gtag('config', 'G-1NCNN1RV05');`}
				</script>
			</Helmet>
			<Header />
			<Menu />

			<main className="relative z-10 w-screen min-h-screen pb-20">
				{children}
				<Clouds />
			</main>
			<Tickertape />
			<Footer />
		</>
	);
};

/* Export
============================================================================= */

export default Layout;
